import type { ComponentProps, ReactNode } from 'react';
import { isArray } from 'lodash/fp';
import classnames from 'classnames/bind';
import * as styles from './ModalBanner.css';

const cx = classnames.bind(styles);

export enum ModalBannerVariant {
    INFO = 'info',
    WARNING = 'warning',
    ERROR = 'error'
}

const VARIANT_CLASSES: Record<ModalBannerVariant, string> = {
    [ModalBannerVariant.INFO]: 'variant-info',
    [ModalBannerVariant.WARNING]: 'variant-warning',
    [ModalBannerVariant.ERROR]: 'variant-error'
};

const renderItem = (msg: string) => <li key={msg}>{msg}</li>;

export interface ModalBannerProps extends ComponentProps<'div'> {
    testId?: string;
    variant?: ModalBannerVariant;
    children?: ReactNode | string[];
}

export function ModalBanner({
    testId,
    className,
    variant = ModalBannerVariant.INFO,
    children,
    ...props
}: ModalBannerProps) {
    const classes = cx('base', VARIANT_CLASSES[variant], className);

    return (
        <div role="alert" data-testid={testId} className={classes} {...props}>
            {isArray(children) ? <ul>{children.map(renderItem)}</ul> : children}
        </div>
    );
}
